/* Hachi Shears — rich interactions: scroll-reveal, sticky bar, magnifier lens, quick-view */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var APPLY = window.HG_APPLY_URL || '/pages/wholesale';
  var QUOTE = window.HG_QUOTE_URL || '/pages/quote';

  /* ---------- 1. Scroll reveal ---------- */
  function initReveal() {
    if (RM || !('IntersectionObserver' in window)) return;
    var sel = '.product-card, .hg-value, .hg-proc, .hg-aud, .hg-tst, .hg-logos, .hg-prt, .hg-marquee, .product-list, .hg-value__card, .hg-tst__card';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('hg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll(sel).forEach(function (el, i) {
      if (el.classList.contains('hg-reveal')) return;
      el.classList.add('hg-reveal');
      el.style.transitionDelay = ((i % 4) * 60) + 'ms';
      io.observe(el);
    });
  }

  /* ---------- 2. Sticky apply / quote bar (product pages) ---------- */
  function initStickyBar() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.hg-stickybar')) return;
    var titleEl = document.querySelector('.product-information h1, .product-title h1, .product-information .product-title, h1');
    var title = titleEl ? titleEl.textContent.trim() : document.title;
    var bar = document.createElement('div');
    bar.className = 'hg-stickybar';
    bar.innerHTML =
      '<span class="hg-stickybar__title">' + title + '</span>' +
      '<span class="hg-stickybar__actions">' +
        '<a class="hg-btn hg-btn--ghost" href="' + QUOTE + '?product=' + encodeURIComponent(title) + '">Request a quote</a>' +
        '<a class="hg-btn" href="' + APPLY + '">Apply for pricing</a>' +
      '</span>';
    document.body.appendChild(bar);
    var pw = document.querySelector('.page-wrapper');
    function getY() { return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0); }
    function onScroll() { bar.classList.toggle('hg-stickybar--show', getY() > 480); }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 4. Quick-view modal (collection cards) ---------- */
  var modal = null;
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'hg-qv';
    modal.innerHTML = '<div class="hg-qv__overlay"></div><div class="hg-qv__panel" role="dialog" aria-modal="true"></div>';
    document.body.appendChild(modal);
    modal.querySelector('.hg-qv__overlay').addEventListener('click', closeQV);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQV(); });
  }
  function closeQV() { if (modal) { modal.classList.remove('hg-qv--open'); document.documentElement.style.overflow = ''; } }
  function openQV(handle) {
    if (!modal) buildModal();
    var panel = modal.querySelector('.hg-qv__panel');
    panel.innerHTML = '<div class="hg-qv__loading">Loading…</div>';
    modal.classList.add('hg-qv--open');
    document.documentElement.style.overflow = 'hidden';
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var imgs = (p.images || []).slice(0, 6);
      var main = imgs[0] || p.featured_image || '';
      panel.innerHTML =
        '<button class="hg-qv__close" aria-label="Close">&times;</button>' +
        '<div class="hg-qv__media"><img class="hg-qv__main" src="' + main + '" alt="' + (p.title || '') + '">' +
          '<div class="hg-qv__thumbs">' + imgs.map(function (s, i) { return '<button class="hg-qv__thumb' + (i === 0 ? ' is-active' : '') + '"><img src="' + s + '" alt=""></button>'; }).join('') + '</div>' +
        '</div>' +
        '<div class="hg-qv__info">' +
          '<h3 class="hg-qv__title">' + (p.title || '') + '</h3>' +
          '<div class="hg-qv__desc">' + (p.description || '') + '</div>' +
          '<div class="hg-qv__actions">' +
            '<a class="hg-btn" href="' + APPLY + '">Apply for pricing</a>' +
            '<a class="hg-btn hg-btn--ghost" href="' + QUOTE + '?product=' + encodeURIComponent(p.title) + '">Request a quote</a>' +
            '<a class="hg-qv__full" href="/products/' + p.handle + '">View full details &rarr;</a>' +
          '</div>' +
        '</div>';
      panel.querySelector('.hg-qv__close').addEventListener('click', closeQV);
      var mainImg = panel.querySelector('.hg-qv__main');
      panel.querySelectorAll('.hg-qv__thumb').forEach(function (t, i) {
        t.addEventListener('click', function () {
          mainImg.src = imgs[i];
          panel.querySelectorAll('.hg-qv__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    }).catch(function () { location.href = '/products/' + handle; });
  }
  function initQuickView() {
    document.querySelectorAll('.product-card').forEach(function (card) {
      if (card.dataset.hgQv) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      card.dataset.hgQv = '1';
      var handle = link.getAttribute('href').split('/products/')[1].split('?')[0].split('#')[0];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hg-qv-btn';
      btn.textContent = 'Quick view';
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openQV(handle); });
      card.appendChild(btn);
    });
  }

  /* ---------- 5. Live scheme switcher (preview only) ---------- */
  var HG_SCHEMES = [
    { id: 'cream-crimson', name: 'Cream & Crimson', group: 'Modern', bg: [244,240,232], fg: [26,24,21], accent: [168,24,19], btn: '#ffffff' },
    { id: 'steel-ink-tempered-indigo', name: 'Tempered Steel & Ink', group: 'Modern', bg: [241,238,231], fg: [26,28,34], accent: [47,64,96], btn: '#ffffff' },
    { id: 'editorial-oxblood-bone', name: 'Bone & Oxblood', group: 'Modern', bg: [246,241,233], fg: [33,29,26], accent: [110,20,35], btn: '#ffffff' },
    { id: 'botanical-olive-heritage', name: 'Heritage Olive', group: 'Modern', bg: [241,236,224], fg: [27,29,23], accent: [60,71,51], btn: '#ffffff' },
    { id: 'quiet-luxury-stone-oat', name: 'Stone & Oat', group: 'Modern', bg: [243,241,234], fg: [34,32,28], accent: [110,106,96], btn: '#ffffff' },
    { id: 'refresh-modern-champagne', name: 'Modern Champagne', group: 'Modern', bg: [244,240,232], fg: [26,24,21], accent: [212,162,58], btn: '#1a1815' },
    { id: 'light-champagne-cream', name: 'Champagne & Cream (current)', group: 'Light', bg: [247,244,238], fg: [28,26,21], accent: [168,127,51], btn: '#ffffff' }
  ];
  function rgbStr(a) { return 'rgb(' + a[0] + ', ' + a[1] + ', ' + a[2] + ')'; }
  function hgHex(a) { return '#' + a.map(function (n) { return ('0' + n.toString(16)).slice(-2); }).join(''); }
  function applyScheme(sc) {
    var st = document.documentElement.style;
    var allBg = HG_SCHEMES.map(function (x) { return rgbStr(x.bg); });
    st.setProperty('--color-background', hgHex(sc.bg));
    st.setProperty('--color-background-rgb', sc.bg.join(' '));
    st.setProperty('--color-foreground', hgHex(sc.fg));
    st.setProperty('--color-foreground-rgb', sc.fg.join(' '));
    ['--color-primary','--color-primary-button-background','--color-primary-button-border',
     '--color-primary-button-hover-background','--color-primary-button-hover-border','--hg-accent'].forEach(function (v) { st.setProperty(v, hgHex(sc.accent)); });
    st.setProperty('--hg-accent-rgb', sc.accent.join(' '));
    st.setProperty('--color-primary-button-text', sc.btn || '#ffffff');
    st.setProperty('--color-primary-button-hover-text', sc.btn || '#ffffff');
    st.setProperty('--hg-hairline', 'rgba(' + sc.fg.join(',') + ',0.12)');
    st.setProperty('--hg-hairline-soft', 'rgba(' + sc.fg.join(',') + ',0.07)');
    document.body.style.backgroundColor = hgHex(sc.bg);
    document.body.style.color = hgHex(sc.fg);
    /* sections set their bg per-section (palette colour) inline or via class —
       match on the COMPUTED colour so hex-inline + class backgrounds both catch */
    document.querySelectorAll('[style*="background"], [class*="section-background"], .color-custom-sections').forEach(function (el) {
      var b = getComputedStyle(el).backgroundColor;
      if (allBg.indexOf(b) !== -1) el.style.setProperty('background-color', hgHex(sc.bg), 'important');
    });
    /* header/announcement scope their colour via a baked `color-#f7f4ee` class —
       remap those elements directly so the header follows the scheme too */
    document.querySelectorAll('[class~="color-#f4f0e8"], [class~="color-#f7f4ee"]').forEach(function (el) {
      el.style.setProperty('--color-background', hgHex(sc.bg));
      el.style.setProperty('--color-background-rgb', sc.bg.join(' '));
      el.style.setProperty('--color-foreground', hgHex(sc.fg));
      el.style.setProperty('--color-foreground-rgb', sc.fg.join(' '));
      el.style.setProperty('background-color', hgHex(sc.bg), 'important');
      el.style.setProperty('color', hgHex(sc.fg), 'important');
    });
    try { localStorage.setItem('hgPreviewScheme', sc.id); } catch (e) {}
  }
  function initSchemeSwitcher() {
    var on = /hgswitch/.test(location.search);
    try { if (on) sessionStorage.setItem('hgPreviewOn', '1'); } catch (e) {}
    var active = false; try { active = sessionStorage.getItem('hgPreviewOn') === '1'; } catch (e) {}
    if (!active) return; /* preview only within a session that opened ?hgswitch — never leaks to customers */
    var saved = null; try { saved = localStorage.getItem('hgPreviewScheme'); } catch (e) {}
    if (saved) { var s0 = HG_SCHEMES.filter(function (x) { return x.id === saved; })[0]; if (s0) applyScheme(s0); }
    if (document.querySelector('.hg-switch')) return;
    var box = document.createElement('div');
    box.className = 'hg-switch';
    box.style.cssText = 'position:fixed;left:14px;bottom:14px;z-index:9999;background:#fff;color:#111;border:1px solid rgba(0,0,0,.15);border-radius:10px;padding:10px;box-shadow:0 12px 40px rgba(0,0,0,.25);font-family:system-ui,sans-serif;font-size:12px;width:200px;max-height:80vh;overflow:auto;';
    var html = '<div style="display:flex;align-items:center;justify-content:space-between;margin:0 0 8px;"><span style="font-weight:600;letter-spacing:.06em;text-transform:uppercase;font-size:10px;opacity:.6;">Preview scheme</span><button id="hg-sw-exit" title="Exit preview" style="background:none;border:0;cursor:pointer;font-size:14px;line-height:1;opacity:.5;color:#111;padding:0 2px;">&times;</button></div>';
    HG_SCHEMES.forEach(function (sc) {
      html += '<button data-id="' + sc.id + '" style="display:flex;align-items:center;gap:8px;width:100%;text-align:left;background:none;border:0;padding:7px 6px;border-radius:6px;cursor:pointer;color:#111;">' +
        '<span style="display:inline-flex;gap:2px;">' +
          '<span style="width:11px;height:14px;border-radius:2px;border:1px solid rgba(0,0,0,.2);background:' + hgHex(sc.bg) + ';"></span>' +
          '<span style="width:6px;height:14px;border-radius:2px;background:' + hgHex(sc.accent) + ';"></span>' +
        '</span>' + sc.name + '</button>';
    });
    box.innerHTML = html;
    document.body.appendChild(box);
    var exit = box.querySelector('#hg-sw-exit');
    if (exit) exit.addEventListener('click', function () {
      try { sessionStorage.removeItem('hgPreviewOn'); localStorage.removeItem('hgPreviewScheme'); } catch (e) {}
      location.href = location.pathname;
    });
    box.querySelectorAll('button[data-id]').forEach(function (b) {
      b.addEventListener('mouseenter', function () { b.style.background = 'rgba(0,0,0,.06)'; });
      b.addEventListener('mouseleave', function () { b.style.background = 'none'; });
      b.addEventListener('click', function () {
        var sc = HG_SCHEMES.filter(function (x) { return x.id === b.getAttribute('data-id'); })[0];
        if (sc) applyScheme(sc);
      });
    });
  }

  /* ---------- 6. Hide the Price filter for non-approved buyers ---------- */
  /* Guests don't see prices (gated), so a price facet is useless to them.
     Approved customers (HG_APPROVED) DO see prices, so they keep it. */
  function initHideGatedFilters() {
    if (window.HG_APPROVED) return;
    if (!/\/collections\//.test(location.pathname) && !/\/search/.test(location.pathname)) return;
    function hide() {
      document.querySelectorAll('.facets__item, .facets__panel').forEach(function (it) {
        if (it.dataset.hgHidden) return;
        var lbl = it.querySelector('.facets__label, summary');
        if (lbl && lbl.textContent.trim().toLowerCase() === 'price') {
          it.style.display = 'none';
          it.dataset.hgHidden = '1';
        }
      });
    }
    hide();
    var host = document.querySelector('.facets') || document.querySelector('main') || document.body;
    if (host && !host.dataset.hgFilterObs) {
      host.dataset.hgFilterObs = '1';
      new MutationObserver(hide).observe(host, { childList: true, subtree: true });
    }
  }

  /* ---------- 7. Count-up stats (About page) ---------- */
  function initCounters() {
    var els = document.querySelectorAll('.hg-count');
    if (!els.length) return;
    function setFinal(el) { el.textContent = (parseInt(el.getAttribute('data-count'), 10) || 0).toLocaleString(); }
    /* Correctness first: if motion is reduced, no rAF, or the tab is hidden
       (rAF is paused when hidden), just show the final numbers. */
    if (RM || document.hidden || !('IntersectionObserver' in window) || !('requestAnimationFrame' in window)) {
      els.forEach(setFinal);
      return;
    }
    function animate(el) {
      var target = parseInt(el.getAttribute('data-count'), 10) || 0;
      var dur = 1100, start = null, done = false;
      function finish() { if (done) return; done = true; setFinal(el); }
      function step(ts) {
        if (done) return;
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString();
        if (p < 1) requestAnimationFrame(step); else finish();
      }
      requestAnimationFrame(step);
      setTimeout(finish, dur + 600); /* belt-and-braces guarantee */
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); animate(e.target); } });
    }, { threshold: 0.3 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAll() {
    try { initReveal(); } catch (e) {}
    try { initStickyBar(); } catch (e) {}
    try { initSchemeSwitcher(); } catch (e) {}
    try { initHideGatedFilters(); } catch (e) {}
    try { initCounters(); } catch (e) {}
    /* Hover magnifier lens removed — the native click-to-open gallery popup already covers "magnify". */
    try { initQuickView(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
